import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import Servicios from "@/pages/Servicios";
import Portafolio from "@/pages/Portafolio";
import SobreMi from "@/pages/SobreMi";
import Contacto from "@/pages/Contacto";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);
  return null;
};

const Layout = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/portafolio" element={<Portafolio />} />
        <Route path="/sobre-mi" element={<SobreMi />} />
        <Route path="/contacto" element={<Contacto />} />
      </Routes>
    </main>
    <Footer />
    <WhatsAppFab />
  </>
);

function App() {
  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#5B4B6E",
              color: "#F7F3EE",
              border: "1px solid #C79A8B",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </ReactLenis>
    </div>
  );
}

export default App;
